import api from "../config/api";
import { TaskAttachment } from "../types/TaskAttachment";

const API_URL = "/taskAttachment";

export const getTaskAttachments = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });

export const getTaskAttachmentById = (id: string) =>
  api.get(`${API_URL}/?id=${id}`);

export const createTaskAttachment = (formdata: FormData) =>
  api.post(`${API_URL}/`, formdata, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const updateTaskAttachment = (id: number, data: TaskAttachment) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteTaskAttachment = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
